import { create } from "@/modules/core/store"

type WeekCopied = {
  boxId: string
  boxName: string
  boxProgramId: string
  boxProgramName: string
  startDate: Date
  endDate: Date
}

type BoxSessionWeekCopyActions = {
  setWeekToCopy: (weekToCopy: WeekCopied) => void
  clearWeekToCopy: () => void
}

type BoxSessionWeekCopyStore = {
  weekToCopy: WeekCopied | null
  actions: BoxSessionWeekCopyActions
}

const useBoxSessionWeekCopyStore = create<BoxSessionWeekCopyStore>()((set) => ({
  weekToCopy: null,
  actions: {
    setWeekToCopy: (weekToCopy: WeekCopied) => set({ weekToCopy }),
    clearWeekToCopy: () => set({ weekToCopy: null }),
  },
}))

export const useBoxSessionWeekCopy = () => useBoxSessionWeekCopyStore((state) => state.weekToCopy)
export const useBoxSessionWeekCopyActions = () => useBoxSessionWeekCopyStore((state) => state.actions)
